import React, { useState, useEffect, useMemo } from "react";
import dayjs from "dayjs";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  Typography,
  FormLabel,
  Popover,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { baseUrl } from "../../../../../../../../../../../network/constants/constants";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "./serviceAddEditForm.css";
import { SketchPicker } from "react-color";
import { getConfig } from "../../../../../../../../../../../network/auth";
import axios from "axios";
import { Alert, Snackbar } from "@mui/material";

const ServiceAddEditForm = ({
  open,
  onClose,
  serviceData,
  categoryList,
  onSubmit,
}) => {
  const [formState, setFormState] = useState({
    service: "",
    category: "",
    description: "",
    open_time: "",
    close_time: "",
    thumb: null,
    features: [{ feature_name: "", color: "" }],
    price_chart: {
      price_chart: "",
      details: "",
      text: "",
    },
    terms_and_condition: "",
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [tempColor, setTempColor] = useState("");

    const [snackbar, setSnackbar] = useState({
      open: false,
      message: "",
      severity: "success",
    });
  

  const handleOpenColorPicker = (event, index, color) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setTempColor(color);
  };

  const handleCloseColorPicker = () => {
    setAnchorEl(null);
    setSelectedIndex(null);
  };
  const handleConfirmColor = () => {
    handleFeatureChange(
      { target: { name: "color", value: tempColor } },
      selectedIndex
    );
    handleCloseColorPicker();
  };

  const handleFeatureChange = (e, index) => {
    const updatedFeatures = formState.features.map((feature, i) =>
      i === index ? { ...feature, [e.target.name]: e.target.value } : feature
    );

    setFormState((prevState) => ({
      ...prevState,
      features: updatedFeatures,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [`${e.target.name}_${index}`]: "",
    }));
  };

  const removeFeature = (index) => {
    const featureId = formState.features[index]?.id;

    axios
      .delete(`${baseUrl}app/features/delete/${featureId}/`, config)
      .then((response) => {

        setFormState((prevState) => ({
          ...prevState,
          features: prevState.features.filter((_, i) => i !== index),
        }));
  
        setSnackbar({
          open: true,
          message: "The feature has been deleted",
          severity: "success",
        });
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: "The feature was not deleted",
          severity: "error",
        });
      });
  };

  useEffect(() => {
    if (serviceData) {
      setFormState((prevState) => ({
        service: serviceData.service,
        category: serviceData.category_id,
        description: serviceData.description,
        open_time: serviceData.open_time,
        close_time: serviceData.close_time,
        thumb: serviceData.thumb || null,
        features: serviceData.features,
        price_chart: serviceData.price_chart,
        terms_and_condition: serviceData?.terms_and_condition,
      }));
    }
    return () => {
      setFormState({
        service: "",
        category: "",
        description: "",
        open_time: "",
        close_time: "",
        thumb: null,
        features: [{ feature_name: "", color: "" }],
        price_chart: {
          price_chart: "",
          details: "",
          text: "",
        },
        terms_and_condition: "",
      });
    };
  }, [serviceData]);

  const [errors, setErrors] = useState({});

  const validationForm = () => {
    const newErrors = {};

    if (!formState.service) newErrors.service = "Service is required";
    if (!formState.category) newErrors.category = "Please select a category";
    if (!formState.description)
      newErrors.description = "Description is required";

    if (!formState.thumb) newErrors.thumb = "Thumb image is required";

    if (formState.price_chart?.price_chart === "") {
      newErrors.price_chart = "Price is required";
    }
    if (formState.price_chart?.text === "") {
      newErrors.text = "Price heading is required";
    }
    if (formState.price_chart?.details === "") {
      newErrors.details = "Price description is required";
    }
    if (formState.terms_and_condition?.terms_and_condition === "") {
      newErrors.terms_and_condition = "Terms and condition is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const categoryNamesWithIds = categoryList.map((category) => ({
    id: category.id,
    name: category.category_name,
  }));

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "thumb" && files.length > 0) {
      setFormState({
        ...formState,
        thumb: files[0],
      });
    } else if (Object.keys(formState.price_chart).includes(e.target.name)) {
      setFormState({
        ...formState,
        price_chart: { ...formState.price_chart, [name]: value },
      });
    } else {
      setFormState({
        ...formState,
        [name]: value,
      });
    }
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  // const handleFeatureChange = (e, index) => {
  //   const updatedFeatures = formState.features.map((feature, i) => {
  //     if (i === index) {
  //       return {
  //         ...feature,
  //         [e.target.name]: e.target.value,
  //       };
  //     }
  //     return feature;
  //   });

  //   setFormState((prevState) => ({
  //     ...prevState,
  //     features: updatedFeatures,
  //   }));
  //   setErrors((prevErrors) => ({ ...prevErrors, [e.target.name]: "" }));
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validationForm()) {
      const formData = {
        ...formState,
        thumb: formState.thumb || serviceData?.thumb,
      };
      onSubmit(formData);
      setFormState({
        service: "",
        category: "",
        description: "",
        open_time: "",
        close_time: "",
        thumb: null,
        features: [{ feature_name: "", color: "" }],
        price_chart: {
          price_chart: "",
          details: "",
          text: "",
        },
        terms_and_condition: "",
      });
      onClose();
    }
  };

  const addFeature = (e) => {
    e.preventDefault();
    setFormState((prevState) => ({
      ...prevState,
      features: [...prevState.features, { feature_name: "", color: "" }],
    }));
  };

  // const removeFeature = (index) => {
  //   setFormState((prevState) => ({
  //     ...prevState,
  //     features: prevState.features.filter((_, i) => i !== index),
  //   }));
  // };

  function handleTimeChange(newValue, timeType) {
    const formattedTime = newValue.format("HH:mm");

    setFormState({ ...formState, [timeType]: formattedTime });
  }

  const config = useMemo(() => {
    return getConfig();
  }, []);

  return (
    <>
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle style={{ color: "#ff4d4d" }}>
        {serviceData ? "Update Service" : "Add Service"}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Service"
          name="service"
          value={formState.service}
          onChange={handleChange}
          margin="dense"
          error={!!errors.service}
          helperText={errors.service}
        />
        <FormControl fullWidth margin="dense" error={!!errors.category}>
          <InputLabel>Category</InputLabel>
          <Select
            name="category"
            label="Category"
            value={formState.category}
            onChange={handleChange}
          >
            {categoryNamesWithIds.map((categoryName) => (
              <MenuItem key={categoryName.id} value={categoryName.id}>
                {categoryName.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          label="Description"
          name="description"
          value={formState.description}
          onChange={handleChange}
          margin="dense"
          multiline
          rows={4}
          error={!!errors.description}
          helperText={errors.description}
        />
        <TextField
          fullWidth
          label="Terms and Conditions"
          name="terms_and_condition"
          value={formState.terms_and_condition}
          onChange={handleChange}
          margin="dense"
          multiline
          rows={4}
          error={!!errors.terms_and_condition}
          helperText={errors.terms_and_condition}
        />
        <span className="thumb-label">Thumbnail:</span>
        <label class="image_input_container" error={!!errors.thumb}>
          {serviceData ? (
            <img
              className="thumb-img"
              src={`${baseUrl}${formState.thumb}`}
              alt=""
            />
          ) : (
            ""
          )}

          <input
            type="file"
            name="thumb"
            onChange={handleChange}
            error={!!errors.thumb}
          />
        </label>
        <Typography gutterBottom className="mt-3">
          Price Details and Timing:
        </Typography>
        <TextField
          margin="dense"
          name="price_chart"
          value={formState.price_chart.price_chart}
          onChange={handleChange}
          label="Price"
          fullWidth
          variant="outlined"
          error={!!errors.price_chart}
          helperText={errors.price_chart}
        />
        <TextField
          margin="dense"
          name="text"
          value={formState.price_chart.text}
          onChange={handleChange}
          label="Price Heading"
          type="text"
          fullWidth
          variant="outlined"
          error={!!errors.text}
          helperText={errors.text}
        />
        <TextField
          margin="dense"
          name="details"
          value={formState.price_chart.details}
          onChange={handleChange}
          label="Price Description"
          type="text"
          fullWidth
          variant="outlined"
          multiline
          rows={4}
          error={!!errors.details}
          helperText={errors.details}
        />

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {/* Open Time Picker */}
          <TimePicker
            label="Open Time"
            value={
              formState.open_time ? dayjs(formState.open_time, "HH:mm") : null
            }
            onChange={(newValue) => {
              if (newValue) {
                handleTimeChange(newValue, "open_time");
              } else {
                setErrors((prevErrors) => ({
                  ...prevErrors,
                  open_time: "Invalid time",
                }));
              }
            }}
            renderInput={(props) => (
              <TextField
                {...props}
                error={!!errors.open_time}
                helperText={errors.open_time}
              />
            )}
            sx={{ width: "100%", marginTop: "5px" }}
          />

          {/* Close Time Picker */}
          <TimePicker
            label="Close Time"
            value={
              formState.close_time ? dayjs(formState.close_time, "HH:mm") : null
            }
            onChange={(newValue) => {
              if (newValue) {
                handleTimeChange(newValue, "close_time");
              } else {
                setErrors((prevErrors) => ({
                  ...prevErrors,
                  close_time: "Invalid time",
                }));
              }
            }}
            renderInput={(props) => (
              <TextField
                {...props}
                error={!!errors.close_time}
                helperText={errors.close_time}
              />
            )}
            sx={{ width: "100%", marginTop: "7px" }}
          />
        </LocalizationProvider>

        <Typography variant="h6" gutterBottom>
          Add Features
        </Typography>

        {/* {formState.features.map((feature, index) => {
          return (
            <div key={index} style={{ display: "flex", alignItems: "center" }}>
              <TextField
                margin="dense"
                placeholder="Enter feature"
                name="feature_name"
                value={feature.feature_name}
                fullWidth
                variant="outlined"
                onChange={(e) => handleFeatureChange(e, index)}
                error={!!errors[`feature_name_${index}`]}
                helperText={errors[`feature_name_${index}`]}
              />
              <FormControl className="">
                <FormLabel>Color</FormLabel>
                <input
                  type="color"
                  value={feature.color}
                  onChange={(e) => handleFeatureChange(e, index)}
                  name="color"
                  style={{
                    marginLeft: "10px",
                    height: "40px",
                    width: "40px",
                    border: "none",
                  }}
                />
                {errors[`color_${index}`] && (
                  <p color="error" className="error-text">
                    {errors[`color_${index}`]}
                  </p>
                )}
              </FormControl>
              <IconButton onClick={() => removeFeature(index)}>
                <CloseIcon />
              </IconButton>
            </div>
          );
        })} */}
        {formState.features.map((feature, index) => (
          <div
            key={index}
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            <TextField
              margin="dense"
              placeholder="Enter feature"
              name="feature_name"
              value={feature.feature_name}
              fullWidth
              variant="outlined"
              onChange={(e) => handleFeatureChange(e, index)}
              error={!!errors[`feature_name_${index}`]}
              helperText={errors[`feature_name_${index}`]}
            />

            <FormControl>
              <FormLabel>Color</FormLabel>
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "4px",
                  background: feature.color,
                  cursor: "pointer",
                  border: "1px solid #ccc",
                }}
                onClick={(event) =>
                  handleOpenColorPicker(event, index, feature.color)
                }
              />
              {errors[`color_${index}`] && (
                <p className="error-text">{errors[`color_${index}`]}</p>
              )}
            </FormControl>

            <IconButton onClick={() => removeFeature(index)}>
              <CloseIcon />
            </IconButton>
          </div>
        ))}

        {/* Color Picker Popover */}
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleCloseColorPicker}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <div
            style={{
              padding: "10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <SketchPicker
              color={tempColor}
              onChange={(color) => setTempColor(color.hex)}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirmColor}
              style={{ marginTop: "10px" }}
            >
              Confirm
            </Button>
          </div>
        </Popover>
        <Button variant="contained" color="secondary" onClick={addFeature}>
          + Add Feature
        </Button>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          color="error"
          style={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="success"
          style={{ textTransform: "none" }}
        >
          {serviceData ? "Update" : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
      <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={() => setSnackbar({ ...snackbar, open: false })}
              severity={snackbar.severity}
              sx={{ width: "100%" }}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
          </>
  );
};

export default ServiceAddEditForm;
